define('app/views/login_menu_view',['app/setup', 'app/models/user'], function(takhfifan) {

  takhfifan.LoginMenuView = takhfifan.BaseView.extend({

    template: ( $('#tkh-login-menu').length > 0 ) ?
      _.template( $('#tkh-login-menu').html() ) : '',

    events: {
      'click #login-toggle': 'toggleLoginForm',
      'click #register-link': 'triggerRegisterForm',
      'click .tkh-account-toggle': 'toggleAccountMenu',
      'click .tkh-logout-btn': 'logout'
    },

    initialize: function() {
      var _this=this;
      takhfifan.eventHub.on('customer:login', function(data) {
        this.model.set(data);
        this.render();
      }, this);
      $('.wrapper').on('click',function(evt){
        _this.$('.tkh-account-menu').fadeOut();
      });
      this.$('.tkh-account-menu').fadeOut();
      this.render();
    },

    render: function() {
      this.$el.html( this.template( this.model.toJSON() ) );
    },

    toggleLoginForm: function(event) {
      takhfifan.eventHub.trigger('customer:loginForm');
      if($('.nav-bar').hasClass('nav-bar-open')){
        $('.nav-bar').removeClass('nav-bar-open').addClass('nav-bar-close');
        $('.nav-bar').css('right', '-85%');
      }
    },

    triggerRegisterForm: function(event) {
      takhfifan.eventHub.trigger('customer:registerForm');
    },

    toggleAccountMenu: function(event) {
      event.stopPropagation();
      this.$('.tkh-account-menu').fadeToggle();
    },

    logout: function(e){
      e.preventDefault();
      webengage.track("logout", {
        "last_name": this.model.changed.name,
        "mobile_number": this.model.changed.mobile,
        "email": this.model.changed.email,
        "customer_id": this.model.changed.id,
      });
      webengage.user.logout();
      this.setResetSessionFlag();
      window.location.replace($(e.currentTarget).attr('href'));
    }

  });

  var user = new takhfifan.User();

  $('.tkh-login-menu').each(function(){
    var $this = $(this);
    new takhfifan.LoginMenuView({
      el: $this,
      model: user
    });
  });

});

